export default __webpack_public_path__ + "static/media/11.8702b644.png";